import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#3D942F\" d=\"M.597.585A1.94 1.94 0 0 1 1.985 0h28.03c.544 0 1.037.225 1.396.592l-15.5 13.974z\"></path><path fill=\"#A6E61F\" d=\"M0 2.045v17.91C0 21.084.89 22 1.985 22h22.067L.596.585C.228.955 0 1.473 0 2.045\"></path><path fill=\"#59BC1C\" d=\"M32 19.955V2.045a2.06 2.06 0 0 0-.59-1.453L15.911 14.566 24.052 22h5.963C31.111 22 32 21.084 32 19.955\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h32v22H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }